/* exists only for things that historically used "after" or "before" */
export default {
  name: 'ember-data',
  initialize() {},
};
